import { useEffect, useCallback} from 'react';
import { useAppDispatch } from './storeHooks';
import { moveHoverIcons_display, setViewportDimensions_display } from './displaySlice';
import { useLocation } from 'react-router-dom';

function useScrollPosition(noListener: boolean = false) {

    const dispatch = useAppDispatch();
    const location = useLocation();

    let timeoutID: ReturnType<typeof setTimeout> | null = null;

    function debouncer(position: number) {

        if (timeoutID) clearTimeout(timeoutID);

        timeoutID = setTimeout(()=> {
            dispatch(moveHoverIcons_display(position));
            dispatch(setViewportDimensions_display());
        }, 0);

    }

    const handleScroll = useCallback(() => {
        const footerHeight = window.innerWidth > 768 ? 60 : 72;
        const overflowY = window.document.scrollingElement?.scrollHeight - window.innerHeight;
        const scrollPosition = window.scrollY;

        //is footer visible initially?
        const underflowY = overflowY - footerHeight;
        const initiallyVisible = underflowY < 0;

        //if footer is initially visible:
        if (initiallyVisible) {
            let footerVisibility = footerHeight - overflowY;

            if (scrollPosition >= 0) { 
                footerVisibility = footerVisibility + scrollPosition;
            }
            
            debouncer(footerVisibility);

        } else if (!initiallyVisible && scrollPosition >= underflowY) {
            const footerVisibility = scrollPosition - underflowY;
            
            debouncer(footerVisibility)          
        } else if (!initiallyVisible) {
            debouncer(0);
        }

    }, [])

    useEffect(() => {

        if (noListener) {
            handleScroll()
            return
        } 

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleScroll);
        };
    }, []);

    useEffect(() => {
        handleScroll();
    }, [location])
}

export default useScrollPosition